import { CancellationReason } from '@core/models/swagger/bff';

export const SUPPORTED_LANGUAGES = ['de'];
export const APP_DEFAULT_LANGUAGE = 'de';
export const MIN_PREMIUM_THRESHOLD = -5;
export const MAX_PREMIUM_THRESHOLD = 5;
export const HEADER_X_TOKEN = 'X-Token';
export const HEADER_X_REFRESH_TOKEN = 'X-Refresh-Token';
export const HEADER_GWCOOKIE = 'GWCOOKIE';
export const BRANCH_PATH_PARAM = 'branchId';
export const PARTNERHIP_CUSTOM_BEHAVIOUR = ['0281', '4013'];
export const ICON_CAR = 'verti-car-alt-24';
export const ICON_USER = 'verti-user-24';
export const ICON_BLOG = 'verti-blog-24';
export const ICON_DOCUMENT = 'verti-document-24';
export const ICON_PAYMENT = 'verti-payment-24';
export const ICON_VAN = 'verti-truck-de-24';
export const ICON_MOTO = 'verti-moto-alt-16';
export const DEFAULT_PARTNERSHIP_ID_VERTIWEB = '0099';
export const DEFAULT_PARTNERSHIP_SHORTNAME_VERTIWEB = 'VRW';
export const COOKIE_PARTNERSHIP_ID = 'ptId';
export const COOKIE_PARTNERSHIP_SHORT_NAME = 'alliance';
export const MGM_LINK = 'https://www.verti-empfehlen.de/?mtm_campaign=Web-quote-buy&mtm_source=verti-quote-buy';
export const RATING_LINK = 'https://de.trustpilot.com/review/verti.de';
export const VERTI_URL = 'https://www.verti.de/';
export const REFERRAL_CODE_ID = 'ZZ';
export const REFERRAL_CODE_ID_URL = 'ZY';
export const REFERRAL_CODE_COOPERATION_ID = 'ZZ';
export const REFERRAL_CODE_MARKETING_ID = '7055TF03';
export const NONE = 'NONE';
export const PARAMS_WHITELIST = ['CAMPAIGN_CODE', 'PROMOTION_CODE', 'REFERRAL_CODE'];
export const DOCUMENTS_NAME = {
  summary: 'Zusammenfassung',
  conditions: 'Bedingungen',
  vertiSummary: 'VertiZusammenfassung',
} as const;

// All URL parameters that can be received in the flow (excluding custom params)
export const URL_PARAMS = {
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_campaign: 'utm_campaign',
  utm_term: 'utm_term',
  utm_content: 'utm_content',
  utm_id: 'utm_id',
  partner_id: 'partnerid',
  gclid: 'gclid',
  click_id: 'click_id',
  dclid: 'dclid',
  gad_source: 'gad_source',
  fbclid: 'fbclid',
  msclkid: 'msclkid',
  gtm_debug: 'gtm_debug',
  twclid: 'twclid',
  ttclid: 'ttclid',
  s_id: 's_id',
  qs: 'qs',
  ak: 'ak',
  entrypoint: 'entrypoint',
  empfehlung: 'empfehlung',
  ch: 'ch',
  einsprungsquelle: 'einsprungsquelle',
  nr: 'nr',
  verVU: 'verVU',
  verVM: 'verVM',
  parVM: 'parVM',
  vorVM: 'vorVM',
  antVM: 'antVM',
  vehicle_kind: 'vehicle_kind',
  test: 'test',
};

export const FOOTER_LINKS = [
  {
    label: 'Impressum',
    type: 'link',
    href: 'https://www.verti.de/impressum/',
    lang: 'de',
    target: '_blank',
  },
  {
    label: 'Datenschutz',
    type: 'link',
    href: 'https://www.verti.de/datenschutz/',
    lang: 'de',
    target: '_blank',
  },
  {
    label: 'Cookies konfigurieren',
    type: 'cookies_management',
    lang: 'de',
  },
  {
    label: 'Erklärung zur Barrierefreiheit',
    type: 'link',
    href: 'https://www.verti.de/barrierefreiheit/',
    lang: 'de',
    target: '_blank',
  },
  {
    label: 'Copyright 2025',
    type: 'copyright',
    lang: 'de',
  },
] as const;

export const OCCUPATIONS = [
  { parameterId: 'Employee', parameterName: 'Angestellte' },
  { parameterId: 'EmployeePublicService', parameterName: 'Angestellte im öffentlichen Dienst' },
  { parameterId: 'PostRailwayTelecom', parameterName: 'Beschäftigte (Post/Bahn/Telekom)' },
  { parameterId: 'BankInsurance', parameterName: 'Beschäftigte (Bank/Versicherung)' },
  { parameterId: 'Worker', parameterName: 'Arbeitende' },
  { parameterId: 'WorkerPublicService', parameterName: 'Arbeitende (ÖD)' },
  { parameterId: 'Official', parameterName: 'Verbeamtete' },
  { parameterId: 'Pensioner', parameterName: 'Personen im Ruhestand' },
  { parameterId: 'PensionerPublicService', parameterName: 'Personen im Ruhestand (ÖD)' },
  { parameterId: 'SelfEmployed', parameterName: 'Selbstständige Personen' },
  { parameterId: 'HousePrivatier', parameterName: 'Haushaltsführende/Privatpersonen' },
  { parameterId: 'Farmer', parameterName: 'Tätige in der Landwirtschaft' },
  { parameterId: 'Student', parameterName: 'Studierende/Lernende' },
  { parameterId: 'Apprentice', parameterName: 'Auszubildende' },
  { parameterId: 'ProfessionalSoldier', parameterName: 'Militärangehörige' },
  { parameterId: 'unemployed', parameterName: 'Ohne aktuelle Erwerbstätigkeit' },
];

export const PREVIOUS_INSURANCE_CANCELLER = [
  { parameterId: CancellationReason.CancelledByInsurer, parameterName: 'Meine Versicherung hat gekündigt' },
  { parameterId: CancellationReason.CancelledByPolicyholder, parameterName: 'Ich habe gekündigt' },
];

export const IBAN_REFS = ['9744', '2341', '3419', '6526'];
